define([
    "./automaticFlowsModule",
    "./automaticFlowsRouter",
    "./automaticFlowsController",
], function () {
});